import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../actions/getUserData";
import { setAppLoader } from "../../actions/setAppLoader";
import success from "../../assets/images/Vector.svg";
import { saveFormPath } from "../../services/userService";
import ErrorModal from "../common/ErrorModal";
import CAlert from "../utils/CAlert";
import CButton from "../utils/CButton";
import CInput from "../utils/CInput";
import { getVkycStatus, initiateVkyc } from "../../services/avanseService";
import { use } from "react";
import CircularLoader from "../utils/CircularLoader";
import { set } from "date-fns";

export default function AvanseVkycVerification({
  setTabValue,
  setStepperCount,
  userDetailId,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [PAN, setPAN] = React.useState("");
  const [aadhaar, setAadhaar] = React.useState("");
  const [isPANVerify, setIsPANVerify] = React.useState(false);
  const [isAadharVerify, setIsAadharVerify] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const params = new URLSearchParams(location.search);
  const userDetails = useSelector((state) => state?.getUserData?.data);
  const [isFetching, setIsFetching] = React.useState(true);
  const userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : null;
  const userId = userData?.userId;
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const [technicalError, setTechnicalError] = React.useState(false);
  const [verificationStatus, setVerificationStatus] = React.useState("PENDING");
  const disabledButton = verificationStatus !== "SUCCESS";
  const [pollingCount, setPollingCount] = React.useState(0);
  const [isPolling, setIsPolling] = React.useState(false);
  const [hasUserInitiated, setHasUserInitiated] = React.useState(false);
  const [vkycWebUrl, setVkycWebUrl] = React.useState('');
  const pollingIntervalRef = React.useRef(null);

  useEffect(() => {
    dispatch(getUserData(userDetailId || localStorage.getItem("detailId")));
  }, [dispatch, userDetailId]);

  useEffect(() => {
            console.log("#FetchingVKYC useEffect status for detailId:", userDetailId || localStorage.getItem("detailId"));

    const fetchVkycStatus = async () => {
      try {
        console.log("#FetchingVKYC status for detailId:", userDetailId || localStorage.getItem("detailId"));
        const status = await getVkycStatus(
          userDetailId || localStorage.getItem("detailId")
        );
        setVerificationStatus(status.response?.vkycStatus);
        setVkycWebUrl(status.response?.vkycWebUrl);
        setIsPolling(true);
      } catch (error) {
        console.error("Error fetching VKYC status:", error);
      } finally {
        setIsFetching(false);
      }
    };
            console.log("#FetchingVKYC useEffect2 status for detailId:", userDetailId || localStorage.getItem("detailId"));

    if (userDetailId || localStorage.getItem("detailId")) {
      fetchVkycStatus();
    }
                console.log("#FetchingVKYC useEffect3 status for detailId:", userDetailId || localStorage.getItem("detailId"));

  }, [userDetailId]);

  const getVericationStatusMessage = (status) => {
    switch (status) {
      case "PENDING":
        return "Initiate Video KYC";
      case "INITIATE":
        return "Initiating VKYC...";
      case "INITIATED":
        return "Verifying Aadhaar...";
        case "IN_PROGRESS":
        if(!hasUserInitiated) {
          return "Resume Video KYC";
        }
        return "Verifying Aadhaar...";
      case "SUCCESS":
        return "VKYC Verified";
      case "EXPPIRED":
        return "Re-Initiate Video KYC";
    }
  };

  const handleInitiateVkycSuccess = (link) => {
    if (!link.startsWith("http://") && !link.startsWith("https://")) {
      link = "https://" + link;
    }
    setVkycWebUrl(link);
    window.location.href = link;
  };

  //Poll getLoanStatus API every 10 seconds
  React.useEffect(() => {
    if (!isPolling || verificationStatus === "PENDING") return;

    const pollLoanStatus = async () => {
      try {
        const response = await getVkycStatus(userDetailId);
        setPollingCount((prev) => prev + 1);
        setVerificationStatus(response.response?.vkycStatus);
        setVkycWebUrl(response.response?.vkycWebUrl);
        console.log("Polling getLoanStatus response:", response);
        if (response?.response?.vkycStatus === "SUCCESS") {
          setIsPolling(false);
          saveFormPath("/loanAgreement", userDetailId);
        } else if (response?.response?.vkycStatus === "EXPIRED") {
          setIsPolling(false);
          setVerificationStatus("EXPIRED");
        }
      } catch (error) {
        console.error("Error polling loan status:", error);
        setPollingCount((prev) => prev + 1);
      }
    };

    pollingIntervalRef.current = setInterval(pollLoanStatus, 20000);

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, [
    isPolling,
    userDetails,
    navigate,
    verificationStatus,
    userDetailId
  ]);

  //Show Loader
  React.useEffect(() => {
    dispatch(setAppLoader(isFetching));
  }, [isFetching]);

  React.useEffect(() => {
    if (verificationStatus === "failure") {
      setError(true);
      setErrorMsg("Aadhaar Verification Failed, Please Try again");
    }
  }, [verificationStatus]);

  React.useEffect(() => {
    if (userDetails?.aadharDetails) {
      setAadhaar(userDetails.aadharDetails.aadharId);
      setIsAadharVerify(true);
      setVerificationStatus("VERIFIED");
    }
    if (userDetails?.userPanCardNumber) {
      setIsPANVerify(true);
      setPAN(userDetails?.userPanCardNumber);
    }
  }, [userDetails]);

   React.useEffect(() => {
    if(verificationStatus === "EXPIRED") {
      initiateVkycProcess();
    }
  }, [verificationStatus]);

  async function initiateVkycProcess() {
    if (!hasUserInitiated && verificationStatus === "IN_PROGRESS") {
      setHasUserInitiated(true);
      setTimeout(() => {
        handleInitiateVkycSuccess(vkycWebUrl);
        setIsPolling(true);
      }, 1000);
      
      return;
    }
    if (verificationStatus !== "PENDING") {
      return;
    }
    setHasUserInitiated(true);
    setVerificationStatus("INITIATE");
    initiateVkyc(userDetailId).then((res) => {
      console.log("initiateDigilocker::::res", res);
      if (res?.success) {
        setVerificationStatus("INITIATED");
        setError(false);
        setErrorMsg("");
        handleInitiateVkycSuccess(res?.response);
      } else {
        setTechnicalError(true);
      }
    });
  }

  // On Save and submit
  async function onSubmitVerified(e) {
    e.preventDefault();
    if (verificationStatus !== "SUCCESS") {
      setError(true);
      setErrorMsg("Please do VKCY to proceed");
      return;
    }
    saveFormPath("/loanAgreement", userDetails?.detailId);
    dispatch(getUserData(userDetailId));
    setTabValue(6);
    // generateEquifax(userDetails?.user?.userName, userDetails?.detailId);
    navigate("/loanAgreement", {
      state: { tabValue: 6, stepperCount: 5, userDetailId: userDetailId },
    });
  }

  function handleBack() {
    navigate("/loanApproved", {
      state: {
        tabValue: 3,
        stepperCount: 3,
        userDetailId: userDetailId || localStorage.getItem("detailId"),
      },
    });
  }

  function getPanOrAadhaarTemplate() {
    if (isAadharVerify) {
      return renderAlreadyVerfied();
    }
    return renderVerifyAadhaar();
  }

  function renderAlreadyVerfied() {
    return (
      <>
        <Typography
          color="textColor"
          variant="h5"
          sx={{ fontWeight: "bold", textAlign: "center", mb: 4 }}
        >
          Validation Complete
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={8} md={6}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <CInput
                  label="Aadhaar Number *"
                  placeholder="Aadhaar Number"
                  disabled={true}
                  value={aadhaar}
                  name="aadhaar"
                />
              </Grid>
              <Grid item sx={{ mt: 5 }}>
                <img src={success} alt="success" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div
          style={{
            pt: 12,
            padding: "100px 0px 0px",
            display: "flex",
            flexDirection: "row",
            justifyContent: `${!matches ? "space-around" : "space-between"}`,
          }}
        >
          {matches && (
            <CButton
              handleClick={() => handleBack()}
              name="Back"
              variant="outlined"
            />
          )}
          <Button
            type="submit"
            sx={{ fontStyle: "Lato" }}
            color="neutral"
            disabled={disabledButton}
            variant="contained"
          >
            Save & Submit
          </Button>
        </div>
      </>
    );
  }

  function renderVerifyAadhaar() {
    return (
      <>
        <Typography
          color="textColor"
          variant="h5"
          sx={{ fontWeight: "bold", textAlign: "center", mb: 4 }}
        >
          Video KYC
        </Typography>

        <Grid container rowSpacing={1} justifyContent="center">
          <Grid item xs={12} sm={8} md={6} className="digilocker-button">
            {verificationStatus !== "PENDING" && verificationStatus !== "SUCCESS" && hasUserInitiated && (
              <Grid item justifyContent="center" style={{ display: "grid" }}>
                <CircularLoader></CircularLoader>
              </Grid>
            )}
            {verificationStatus === "IN_PROGRESS" && !hasUserInitiated && (
              <Grid item justifyContent="center" style={{ display: "gird" }}>
                <Typography
              color="textColor"
              variant="body2"
              sx={{ textAlign: "center" }}
            >
             Looks like you have initiated the VKYC process already. Please complete it by clicking on RESUME VKYC button.
            </Typography>
              </Grid>
            )}
            <CButton
              handleClick={initiateVkycProcess}
              variant={
                (verificationStatus === "PENDING" || verificationStatus === "IN_PROGRESS") && !hasUserInitiated ? "contained" : "outlined"
              }
              name={getVericationStatusMessage(verificationStatus)}
              mt={4} // Adjust width as necessary
            />
          </Grid>
          <Grid item>
            {verificationStatus === "SUCCESS" ? (<Typography
              color="textColor"
              variant="body2"
              sx={{ textAlign: "center" }}
            >
              Your video KYC has been successfully completed. Please proceed to the next step.
            </Typography>): (<Typography
              color="textColor"
              variant="body2"
              sx={{ textAlign: "center" }}
            >
              Your Aadhaar will be verified via Digilocker & video KYC with trusted agents  (Govt. of India
              trusted platform).
            </Typography>)}
          </Grid>
          {errorMsg && (
            <Grid item>
              <Typography
                color="textColor"
                variant="body2"
                sx={{ textAlign: "center", color: "red" }}
              >
                {errorMsg}
              </Typography>
            </Grid>
          )}
        </Grid>
        <div
          style={{
            pt: 12,
            padding: "100px 0px 0px",
            display: "flex",
            flexDirection: "row",
            justifyContent: `${!matches ? "space-around" : "space-between"}`,
          }}
        >
          {matches && (
            <CButton
              handleClick={() => handleBack()}
              name="Back"
              variant="outlined"
            />
          )}
          <Button
            type="submit"
            sx={{ fontStyle: "Lato" }}
            color="neutral"
            disabled={disabledButton}
            variant="contained"
          >
            Save & Submit
          </Button>
        </div>
      </>
    );
  }

  return (
    <form
      onSubmit={(e) => onSubmitVerified(e)}
      className="applicationFormContainer"
    >
      {error && <CAlert open={error} message={errorMsg} severity="error" />}

      {!matches && (
        <Box sx={{ display: "flex" }}>
          <ArrowBackIosIcon onClick={() => handleBack()} />
        </Box>
      )}

      {getPanOrAadhaarTemplate()}

      {technicalError && (
        <ErrorModal
          open={technicalError}
          setOpen={setTechnicalError}
          isTechnicalError={true}
        />
      )}
    </form>
  );
}
